module.exports = __webpack_public_path__ + "static/media/backGround.c06210e1.png";